define.alias("shared/components/shared/profile-categorization/categorize-steps", "media/components/shared/profile-categorization/categorize-steps");